import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_render_export_data_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { description: string, export_id: string, username: string, render: { type: ('report' | 'data'), file_type: ('pdf' | 'html' | 'csv' | 'xlsx'), module_id: string, component_id: string, inputs?: any, header_mappings?: any }, odata_limit: number, wait_for_result?: boolean }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.description)) {
      $missingRequiredInParams.push('\'description\'');
    }
    if (isNil($inParams.export_id)) {
      $missingRequiredInParams.push('\'export_id\'');
    }
    if (isNil($inParams.username)) {
      $missingRequiredInParams.push('\'username\'');
    }
    if (isNil($inParams.render)) {
      $missingRequiredInParams.push('\'render\'');
    }
    if (isNil($inParams.odata_limit)) {
      $missingRequiredInParams.push('\'odata_limit\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

